import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Navigator } from "src/app/services/routing/navigator";
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-popover-pre-geo-info',
  templateUrl: './popover-pre-geo-info.component.html',
  styleUrls: ['./popover-pre-geo-info.component.scss'],
})
export class PopoverPreGeoInfoComponent implements OnInit {
  public jurisdiction;

  constructor(
    public navigator: Navigator,
    public popOverCtrl:PopoverController,
    public config:ConfigService,
    public appStorageService:AppstorageTsService,) { }

  async ngOnInit() {
    this.jurisdiction = await this.appStorageService.getJurisdiction();

  }


  onContinue() {
    this.popOverCtrl.dismiss( true);
  }

  onCancel(){
    this.popOverCtrl.dismiss( false);
  }

  closePopover() {
    this.popOverCtrl.dismiss( false);
  }
}
